import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row, Media, Input } from "reactstrap";
import { Btn, H3, Breadcrumbs, H4 } from "../../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import Typeahead from "../../../CommonElements/TypeAhead";
import {
    Cancel, Save, department, Email, employmentType, FirstName, geofenceZone, hourlyRate, joinDate, Language, LastName, Locale, Locality, MobileNo, Password,
    Pincode,
    Role, shift, staff, State, Status, stockAssignment, UserAgent, zipcode
} from "../../../Constant";
import {
    getRole, getUsers, getUsersRole, getuserRole,
    getShiftSelect, getShiftSelectRole, showStaffList, showStaffListRole,
    storeStaffList, storeStaffListRole, updateStaffList, updateStaffListRole,
    getRoleUserSelect, getRoleUserSelectRole
} from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import HandleApiError from "../../Common/ErrorImport/ErrorImport";
import DatePicker from "react-datepicker";
import moment from "moment";
import Button from "../../Common/Elements/Button";

const schema = yup.object().shape({
    staff: yup.mixed().required("Staff is required").label("Staff"),
    role: yup.mixed().required("Role is required").label("Role"),
    shift: yup.mixed().required("Shift is required").label("Shift"),
    joinDate: yup.date().required("Join date is required").typeError("Join date is required").label("Join date"),
});

const AddEditStaff = () => {
    const [searchParams] = useSearchParams();
    const staffListId = searchParams.get("id");
    const isEdit = !!staffListId;

    const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            role: null,
            shift: null,
            joinDate: null,
            geofenceZone: null,
            hourlyBaseRate: "",
            overtimeRate: "",
            restDayOT: "",
            holidayPay: "",
            nightDifferential: "",
            lateDeduction: "",
        },
    });

    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const navigate = useNavigate();
    const [showPayrollDetails, setShowPayrollDetails] = useState(false);
    const [staffList, setStaffList] = useState([]);
    const [shiftList, setShiftList] = useState([]);
    const [geofenceList, setGeofenceList] = useState([]);

    const fetchStaffByRole = async (roleId) => {
        if (!roleId) {
            setStaffList([]);
            return;
        }
        setLoading(true);
        try {
            const endpoint = authState.userRole === 1 ? getRoleUserSelect : getRoleUserSelectRole;
            const response = await getClientUrlDataToken(
                authState.apiUrl,
                `${endpoint}?role_id=${roleId}`
            );
            if (response.status === true) {
                const data = response.data.data || response.data || [];
                const mappedStaff = data.map((item) => ({
                    value: item.user_id || item.id,
                    label: item.user_name || item.name || `${item.first_name || ''} ${item.last_name || ''}`.trim() || `User #${item.user_id || item.id}`
                }));
                setStaffList(mappedStaff);
            } else {
                toast.error(response.data?.message || "Failed to load staff list for selected role");
                setStaffList([]);
            }
        } catch (err) {
            toast.error("An error occurred while loading staff list");
            setStaffList([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchShifts = async () => {
        try {
            const endpoint = authState.userRole === 1 ? getShiftSelect : getShiftSelectRole;
            const response = await getClientUrlDataToken(authState.apiUrl, endpoint);
            if (response.status === true) {
                const data = response.data.data || response.data || [];
                const mappedShifts = data.map((item) => ({
                    value: String(item.id),
                    label: item.name || item.title || `Shift #${item.id}`
                }));
                setShiftList(mappedShifts);
            } else {
                toast.error("Failed to load shift list");
            }
        } catch (err) {
            console.error("Error loading shifts:", err);
            toast.error("An error occurred while loading shifts");
        }
    };

    const fetchGeofenceOptions = async () => {
        try {
            const endpoint = authState.userRole === 1
                ? '/admin/get-geofence-location'
                : '/get-geofence-location';
            const response = await getClientUrlDataToken(authState.apiUrl, endpoint);
            if (response.status === true) {
                const data = response.data.data || response.data || [];
                const mappedGeofence = data.map((item) => ({
                    value: item.id,
                    label: item.name || `Zone ${item.id}`
                }));
                setGeofenceList(mappedGeofence);
                return mappedGeofence;
            } else {
                toast.error("Failed to load geofence locations");
            }
        } catch (err) {
            console.error("Error loading geofence locations:", err);
        }
        return [];
    };

    const RoleData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getRole : getuserRole);
        if (data.status === true) {
            const mappedrole = data.data.map((items) => ({
                value: items.id,
                label: items.name
            }));
            setRoles(mappedrole);

        } else {
            HandleApiError(data.status);
        }
    };

    const fetchStaffDetails = async (geofences) => {
        setLoading(true);
        try {
            const endpoint = authState.userRole === 1 ? showStaffList : showStaffListRole;
            const response = await getClientUrlDataToken(
                authState.apiUrl,
                `${endpoint}?id=${staffListId}&staff_list_id=${staffListId}`
            );
            if (response.status === true) {
                const staffData = Array.isArray(response.data.data)
                    ? response.data.data[0]
                    : response.data.data;

                if (staffData) {

                    setValue("role", { value: staffData.role_id, label: staffData.role_name });
                    fetchStaffByRole(staffData.role_id);

                    setValue("staff", staffData.employee_id ? { value: staffData.employee_id, label: staffData.employee_name || `Employee #${staffData.employee_id}` } : null);
                    setValue("shift", staffData.shift_id ? { value: String(staffData.shift_id), label: staffData.shift_name || `Shift #${staffData.shift_id}` } : null);
                    setValue("joinDate", new Date(staffData.join_date));
                    if (staffData.geofence_zone_id) {

                        setValue("geofenceZone", { label: staffData.geofence_zone, value: staffData.geofence_zone_id })
                    }

                    setValue("hourlyBaseRate", staffData.hourly_base_rate || "");
                    setValue("overtimeRate", staffData.overtime_rate || "");
                    setValue("restDayOT", staffData.rest_day_ot || "");
                    setValue("holidayPay", staffData.holiday_pay || "");
                    setValue("nightDifferential", staffData.night_differential || "");
                    setValue("lateDeduction", staffData.late_deduction || "");
                    if (staffData.hourly_base_rate || staffData.overtime_rate) {
                        setShowPayrollDetails(true);
                    }
                }
            } else {
                toast.error(response.data?.message || "Failed to load staff details");
            }
        } catch (error) {
            console.error("Error loading staff details:", error);
            toast.error("An error occurred while loading staff details");
        } finally {
            setLoading(false);
        }
    };

    const onSubmit = async (data) => {
        setLoading(true);
        const postRequest = {
            employee_id: data.staff?.value,
            shift_id: data.shift?.value,
            join_date: data.joinDate ? moment(data.joinDate).format("YYYY-MM-DD") : null,
            geofence_zone: data?.geofenceZone?.value || null,
            hourly_base_rate: data.hourlyBaseRate ? parseFloat(data.hourlyBaseRate) : null,
            overtime_rate: data.overtimeRate ? parseFloat(data.overtimeRate) : null,
            rest_day_ot: data.restDayOT || null,
            holiday_pay: data.holidayPay ? parseFloat(data.holidayPay) : null,
            night_differential: data.nightDifferential || null,
            late_deduction: data.lateDeduction ? parseFloat(data.lateDeduction) : null
        };

        if (isEdit) {
            postRequest.staff_list_id = staffListId;
        }

        const endpoint = isEdit
            ? (authState.userRole === 1 ? updateStaffList : updateStaffListRole)
            : (authState.userRole === 1 ? storeStaffList : storeStaffListRole);

        try {
            const response = await postClientUrlWithToken(
                authState.apiUrl,
                endpoint,
                postRequest
            );

            if (response.status === 200) {
                if (response.data.status === true) {
                    toast.success(response.data.message || (isEdit ? "Staff details updated successfully!" : "Staff details added successfully!"));
                    navigate(`${process.env.PUBLIC_URL}/attendance/employee-list`);
                } else {
                    if (Array.isArray(response.data.message)) {
                        response.data.message.forEach((err) => {
                            toast.error(err);
                        });
                    } else {
                        toast.error(response.data.message || "An error occurred");
                    }
                }
            } else {
                toast.error("Failed to save staff details. Please try again.");
            }
        } catch (err) {
            console.error("Error saving staff details:", err);
            toast.error("An error occurred while saving staff details");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setLoading(true);
        RoleData();
        fetchShifts();
        const geofences = fetchGeofenceOptions();
        if (isEdit) {
            fetchStaffDetails(geofences);
        }
        setLoading(false);

    }, []);

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={isEdit ? "Edit Staff" : "Add Staff"} parent="Attendance" title={isEdit ? "Edit Staff" : "Add Staff"} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{isEdit ? "Edit Staff" : "Add Staff"}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3 p-3">
                            <Col md="6">
                                <Label className="form-label" >{Role} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="role"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={roles}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                fetchStaffByRole(value?.value);
                                                setValue("staff", null);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.role?.message}</p>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" >{staff} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="staff"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={staffList}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.staff?.message}</p>
                            </Col>
                            <Col md="6">
                                <Label className="form-label">{shift} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="shift"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={shiftList}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.shift?.message}</p>
                            </Col>

                            <Col md="6">
                                <Label className="form-label">{joinDate} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="joinDate"
                                    control={control}
                                    render={({ field }) => (
                                        <DatePicker
                                            id="service_date"
                                            placeholderText="dd/mm/yyyy"
                                            dateFormat="dd/MM/yyyy"
                                            autoComplete="off"
                                            selected={field.value}
                                            onChange={(date) => field.onChange(date)}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            className="form-control"
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.joinDate?.message}</p>
                            </Col>
                            <Col md="6">
                                <Label className="form-label">{geofenceZone}</Label>
                                <Controller
                                    name="geofenceZone"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={geofenceList}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                            </Col>
                        </Row>

                        {/* Staff Payroll Details Section */}
                        <div className="mt-4 mb-3 pb-2 gap-3 d-flex align-items-center ">
                            <H4 >Payroll Details</H4>
                            <Media body className={`text-end switch-md icon-state`}>
                                <Label className="switch">
                                    <Input type="checkbox"
                                        checked={showPayrollDetails}
                                        onChange={(e) => setShowPayrollDetails(e.target.checked)}
                                    />
                                    <span className="switch-state" ></span>
                                </Label>
                            </Media>
                        </div>

                        {showPayrollDetails && (
                            <Row className="g-3 p-3 pt-0">
                                <Col md="6">
                                    <Label className="form-label">Hourly base rate</Label>
                                    <input
                                        type="number"
                                        step="any"
                                        className="form-control"
                                        placeholder="Hourly base rate "
                                        {...register("hourlyBaseRate")}
                                    />
                                </Col>
                                <Col md="6">
                                    <Label className="form-label">Overtime rate</Label>
                                    <input
                                        type="number"
                                        step="any"
                                        className="form-control"
                                        placeholder="Overtime rate"
                                        {...register("overtimeRate")}
                                    />
                                </Col>
                                <Col md="6">
                                    <Label className="form-label">Rest day OT</Label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Rest day OT (e.g. 1.5x)"
                                        {...register("restDayOT")}
                                    />
                                </Col>
                                <Col md="6">
                                    <Label className="form-label">Holiday pay</Label>
                                    <input
                                        type="number"
                                        step="any"
                                        className="form-control"
                                        placeholder="Holiday pay "
                                        {...register("holidayPay")}
                                    />
                                </Col>
                                <Col md="6">
                                    <Label className="form-label">Night differential</Label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Night differential (e.g. 10%)"
                                        {...register("nightDifferential")}
                                    />
                                </Col>
                                <Col md="6">
                                    <Label className="form-label">Late deduction</Label>
                                    <input
                                        type="number"
                                        step="any"
                                        className="form-control"
                                        placeholder="Late deduction per hour "
                                        {...register("lateDeduction")}
                                    />
                                </Col>
                            </Row>
                        )}

                        <div className="d-flex justify-content-end gap-2 mt-3">
                            <Button className='btn btn-light' type="button" onClick={() => navigate(`${process.env.PUBLIC_URL}/attendance/employee-list`)}>
                                {Cancel}
                            </Button>
                            <Btn attrBtn={{ color: "primary" }} type="submit">
                                {Save}
                            </Btn>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default AddEditStaff;
